// extracted by mini-css-extract-plugin
module.exports = {"ObliqueSpacer":"Vectors_ObliqueSpacer__4bDNw","ObliqueCard":"Vectors_ObliqueCard__bRtRk"};